export default __webpack_public_path__ + "static/media/block-about-cards-2.06640381.webp";